import ko from 'knockout';
import { openPopup, closePopups } from '../../init';

export interface CustomConfirmPopupModelOptions {
    title?: string;
    content?: string;
    confirmText?: string;
    onClose?: () => void;
    onConfirm?: () => void;
}

export class CustomConfirmPopupModel {
    title: KnockoutObservable<string>;
    content: KnockoutObservable<string>;
    confirmText: KnockoutObservable<string>;
    
    onClose: () => void;
    onConfirm: () => void;
    
    constructor(options: CustomConfirmPopupModelOptions = {}) {
        this.title = ko.observable<string>(options.title || 'Let op');
        this.content = ko.observable<string>(options.content || 'Weet u zeker dat u door wilt gaan?');
        this.confirmText = ko.observable<string>(options.confirmText || 'OK');
        
        if (options.onClose) {
            this.onClose = options.onClose;
        }
        
        if (options.onConfirm) {
            this.onConfirm = options.onConfirm;
        }
    }
    
    init(options: CustomConfirmPopupModelOptions) {
        this.title(options.title || 'Let op');
        this.content(options.content || 'Weet u zeker dat u door wilt gaan?');
        this.confirmText(options.confirmText || 'OK');

        if (options.onClose) {
            this.onClose = options.onClose;
        }

        if (options.onConfirm) {
            this.onConfirm = options.onConfirm;
        }
        
        openPopup('custom-confirm-popup')
    }

    closePopup() {
        closePopups();
        
        if (this.onClose) {
            this.onClose();
        }
    }
    
    confirm() {
        closePopups();

        if (this.onConfirm) {
            this.onConfirm();
        }
    }
}
